module.exports = __webpack_public_path__ + "img/CTA-Arrow-white.7cf50015.svg";